import React, { useState, useEffect, useReducer, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import { Loader } from '@googlemaps/js-api-loader';
import { useTranslation } from 'react-i18next'
import { gettime3 } from '../../utils/time'
import { gethome, eventperson, countrylocation } from '../../utils/api'
import axios from "axios";
import LuckyBox from '../../static/img/LuckyBox.png'
import Headers from './Headers'
import { Cell, Loading } from '@nutui/nutui-react';
import { Toast } from 'zarm';
import { InfiniteScroll } from 'antd-mobile'
import {key} from './key'

const Selected = {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#735BF2',
    borderRadius: '5px',
    display: 'flex',
    height: '32px',
    fontWeight: 700
    , cursor: 'pointer'
}

const notselected = {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '5px',
    display: 'flex',
    height: '32px', cursor: 'pointer', fontWeight: 400
}



const Home: React.FC = () => {
    const { t, i18n } = useTranslation()
    let [show1, getshow1] = useState(false);

    let [country, getcountry] = useState(localStorage.getItem('country')) as any;

    let countryRef = useRef('');

    useEffect(() => {
        countryRef.current = country
    }, [country])


    let [country2, getcountry2] = useState('')

    let countryRef2 = useRef('');

    useEffect(() => {
        countryRef2.current = country2
    }, [country2])

    // let [country, getcountry] = useState(localStorage.getItem('country')) as any;
    let [oldCountry, getoldCountry] = useState(localStorage.getItem('country')) as any;
    let [upcoming, getupcoming] = useState([]) as any;
    let upcomingRef = useRef([]) as any;



    useEffect(() => {
        upcomingRef.current = upcoming
    }, [upcoming])
    let [num, setNum] = useState(0)
    let [tabSelected, getSelected] = useState(0);


    let Numref = useRef(num);
    const myRef = useRef(tabSelected);

    useEffect(() => {
        Numref.current = num
    }, [num])

    const cusBgNotify = (message: string) => {

        Toast.show(message);
    }


    const handleMapClick = async (pos: any) => {
        try {
            const response = await axios.get(
                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${pos.lat},${pos.lng}&key=${key}&language=en-US`
            );

            const countrys = response.data.results[response.data.results.length - 1].formatted_address
            const tlocations = response.data.results[0].formatted_address
            // getcountry(response.data.results[response.data.results.length - 1].formatted_address)

            countryRef2.current = response.data.results[response.data.results.length - 1].formatted_address
            getcountry2(countryRef2.current)


            if (localStorage.getItem('country') != countrys) {
                if (localStorage.getItem('countryshow') == '0') {
                    let a = '1'
                    localStorage.setItem('countryshow', a)
                    getcountrylocation(countrys, tlocations)
                } else {
                    console.log(1111111111111, countrys)
                    getDate()
                }

            } else {
                getDate()
            }

        } catch (error) {
            console.error(error);
        }
    }

    const Switchcountrylocation = (bol: boolean) => {
        getshow1(false)
        if (bol) {
            
            localStorage.setItem('country', country2)
        } else {
            let countrys: any = ''
            localStorage.setItem('country', '')
            countrys = localStorage.getItem('country')

            countryRef.current = ''
            getcountry(countryRef.current)
            getDate()

        }
    }

    let [total, settotal] = useState(0)
    let totalref = useRef(total);
    useEffect(() => {
        totalref.current = total
    }, [total])

    const getDate = async () => {
        setshowhasMore(true)
        setHasMore(true)
        let pageSize = 10
        Numref.current = Numref.current + 1
        setNum(Numref.current)
        await gethome({
            eventCountry: countryRef.current,
            state: myRef.current,
            // pageNum: Numref.current,
            current: Numref.current,
            pageSize: pageSize
        }).then((res) => {

            let data = geif()
            settotal(res.total)
            if (res.rows.length > 0) {
                res.rows.forEach((item: any, index: any) => {
                    item.time = gettime3(item.eventStartTime, item.eventEndTime)
                    item.sdmUsers.forEach((i: any) => {
                        i.c = color16()
                        i.imgUrl = i.imgUrl + ''

                    })

                    item.people = 0
                    eventperson({
                        linUserIds: data,
                        eventId: item.eventId
                    }).then((re) => {


                        // if (re.data) {
                        if (re.data) {
                            item.people = re.data.friends
                        }

                        if (index == res.rows.length - 1) {
                            let tmp = upcomingRef.current
                            tmp.push(...res.rows)
                            console.log(tmp,99999999999999999999);
                            tmp.forEach((item: any) => {
                                if (item.sdmUsers[0]) {
                                    item.sdmUsers.forEach((item1: any) => {
                                        if (item1.imgUrl == undefined || item1.imgUrl == null || item1.imgUrl == 'null' || item1.imgUrl == 'undefined')
                                          item1.imgUrl = ''
                                    })
                                }
                            })
                            getupcoming([...tmp])
                            console.log('Get data',tmp)

                            setHasMore(true)
                            setshowhasMore(false)

                            if (res.total > upcomingRef.current.length) {
                                setHasMore(true)
                            } else {
                                console.log('Cannot drop down to refresh')
                                setHasMore(false)
                            }
                        }
                    }
                    );
                });
            } else {
                setHasMore(false)
                return false
            }
        }
        );
    }

    const geif = () => {
        const data: any = []
        let data2: any = []
        data2 = localStorage.getItem('getMyContacts')
        data2 = JSON.parse(data2)
        let Frienddata = data2 ? data2 : []
        if (Frienddata.length > 0) {

            data2.forEach((item: any) => {
                data.push(item.userId)
            })
        }
        return data
    }



    const Gethomedata = (num: number) => {
        myRef.current = num
        upcomingRef.current = []
        getSelected(num)
        Numref.current = 0
        getDate()
    }




    let [show2, setshow2] = useState(false)

    const getshow2 = () => {
        setshow2(!show2)
    }



    let [userinformationdata, setuserinformationdata] = useState('')
    let [userName, setuserName] = useState('')
    let [imgUrls, setimgUrl] = useState('')
    let [walletAddressMetamask, setwalletAddressMetamask] = useState('')



    let [randomcolor, setcolor] = useState('') as any
    const color16 = () => {
        var r = Math.floor(Math.random() * 200);
        var g = Math.floor(Math.random() * 200);
        var b = Math.floor(Math.random() * 200);
        // var color = '#' + r.toString(16) + g.toString(16) + b.toString(16);

        // var color = '#' + r.toString(16) + g.toString(16) + b.toString(16);
        var color = 'rgb(' + r + ',' + g + ', ' + b + ')';

        let color2 = localStorage.getItem('randomcolor')
        if (color2) {
            setcolor(color2)
        } else {
            localStorage.setItem('randomcolor', color)
            setcolor(color)
        }
        return color
    }


    let [countrylocationdata, setcountrylocationdata] = useState([]) as any

    const getcountrylocation = (countrys: string, tlocations: string) => {

        countrylocation({
            country: countrys,
            location: tlocations
        }).then((res) => {

            if (res.data) {
                getshow1(true)
                setcountrylocationdata(res.data)
            } else {
                countryRef.current = ''
                getcountry(countryRef.current)
                getDate()
            }
        })
    }



    useEffect(() => {

        console.log('May 6, 10:00 packing')
        color16()

        let userinformationdata: any = []
        userinformationdata = localStorage.getItem('userinformation')
        userinformationdata = JSON.parse(userinformationdata)

        let userName = localStorage.getItem('userName')
        let Name = userinformationdata.userName ? userinformationdata.userName : userName
        let imgUrlavatar = localStorage.getItem('avatar')
        let imgUrl = imgUrlavatar ? imgUrlavatar : ''
        if (imgUrl == "undefined") {
            imgUrl = ''
        }

        console.log('imgUrl', imgUrl);
        
        // let imgUrl = imgUrlavatar ? imgUrlavatar : ''

        setuserinformationdata(userinformationdata)
        let wallsdkid = userinformationdata.walletAddressMetamask.slice(0, 3) + '...' + userinformationdata.walletAddressMetamask.slice(userinformationdata.walletAddressMetamask.length - 4, userinformationdata.walletAddressMetamask.length)
        setuserName(Name)
        setimgUrl(imgUrl)
        setwalletAddressMetamask(wallsdkid)
        
        // let c = oldCountry ? oldCountry : 'United States'


        // getDate() //删除

        const loader = new Loader({
            apiKey: key,
            version: 'weekly',
            language: 'en-US'
        });

        loader.load().then((e) => {
            // Try HTML5 geolocation.

            if (navigator.geolocation) {


                navigator.geolocation.getCurrentPosition(
                    (position: GeolocationPosition) => {
                        const pos = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                        };
                        console.log(pos, 'Longitude and latitude')
                        handleMapClick(pos)
                    },
                    (err) => {
                        cusBgNotify(err.message)

                        getDate()

                        console.log(err, 'Error message')
                    }
                );
            } else {

                cusBgNotify('Sorry, your device does not support address access and has used an old address')


                getDate()

            }

        });

        document.addEventListener('scroll', scrollEvent)
        // document.addEventListener('scroll',debounce(scrollEvent, 500))
        return () => {
            // document.removeEventListener('scroll',debounce(scrollEvent, 500));
            document.removeEventListener('scroll', scrollEvent);
        };
    }, []);


    const setlanguage = () => {
        // i18n.changeLanguage(i18n.language == 'en' ? 'zh' : 'en')
        if (i18n.language == 'en') {
            i18n.changeLanguage('zh')
            localStorage.setItem('language', 'zh-CN')
            localStorage.setItem('lang', 'zh')
            setshow2(false)
            window.history.go(0);
        } else {
            i18n.changeLanguage('en')
            localStorage.setItem('language', 'en-US')
            localStorage.setItem('lang', 'en')
            setshow2(false)
            window.history.go(0);
        }

    }



    function debounce(func: any, wait: any) {
        var timeout: any;
        return function () {
            clearTimeout(timeout);
            timeout = setTimeout(func, wait);
        };

    }

    const scrollEvent = debounce(() => {
        let html = document.documentElement || document.body
        if (html.scrollTop >= html.scrollHeight - html.clientHeight - 100) {
            if (totalref.current > upcomingRef.current.length) {
                // debounce(scrollEvent, 500)
                getDate()
            } else {
                setHasMore(false)
            }
        }
    }, 500)

    const [hasMore, setHasMore] = useState(true)
    const [showhasMore, setshowhasMore] = useState(false)
    async function loadMore() {

    }



    return <div >
        <div style={{ position: 'relative', color: '#FFF' }}>
            {
                show1 &&
                <div style={{ position: 'absolute', top: '112px', zIndex: 1001, display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ width: '360px', height: '260px', backgroundColor: '#3D4147', opacity: 1, borderRadius: 10 }}>
                        <div style={{ alignItems: 'center', justifyContent: 'center', margin: 25, display: 'flex', flexDirection: 'column', paddingTop: '20px' }}>
                            <div style={{ textAlign: 'center', fontSize: '16px', color: '#fff', fontWeight: 700, margin: 5 }}>{t('PositioningshowsyouinSingapore')}</div>
                            <div style={{ textAlign: 'center', fontSize: '20px', color: '#fff', fontWeight: 700, margin: 5 }}>{country2}</div>
                            <div style={{ textAlign: 'center', fontSize: '13px', color: '#BABBBE', margin: 5 }}>{t('Doyouwanttoexploresideeventsof')}</div>
                            <div style={{ textAlign: 'center', fontSize: '13px', color: '#BABBBE', margin: 5,overflow: 'hidden', whiteSpace: 'nowrap',
                                                            textOverflow: 'ellipsis', width: '65vw' }}>{countrylocationdata.eventName}?</div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', margin: 20 }}>
                                <div style={{
                                    backgroundColor: '#50545A', width: '155px', height: '48px', borderRadius: 10, marginRight: 10, fontSize: '16px',
                                    color: '#fff', textAlign: 'center', lineHeight: '48px', cursor: 'pointer'
                                }} onClick={() => Switchcountrylocation(false)}>
                                    {t('NO')}
                                </div>
                                <Link to={`/eventdetails?eventId=${countrylocationdata.eventId}&country=${country}`
                                }
                                    style={{ color: '#FFF', textDecorationLine: 'none' }}

                                >
                                    <div style={{
                                        backgroundColor: '#735BF2', width: '155px', height: '48px', borderRadius: 10, marginLeft: 10,
                                        fontSize: '16px', color: '#fff', textAlign: 'center', lineHeight: '48px', cursor: 'pointer'
                                    }}
                                        onClick={() => Switchcountrylocation(true)}
                                    >
                                        {t('YES')}
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {
                show1 && <div style={{ backgroundColor: '#000', width: '100%', height: '100%', zIndex: 1000, opacity: 0.5, position: 'absolute' }}>
                </div>
            }
            {/* <Headers /> */}
            <div style={{ position: 'relative' }}>
                <div style={{
                    backgroundColor: '#202225',
                    height: '60px',
                    lineHeight: '60px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    color: '#FFF'
                }}>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }} >
                        <img src={require("../../static/img/Meetup.png")} style={{ width: '24px', height: '24px', marginLeft: '16px' }} alt="" />
                        <img src={require("../../static/img/Transfer.png")} style={{ width: '75px', height: '17px', marginLeft: '10px' }} alt="" />
                        {/* <div >Transfer</div> */}
                        {/* <div style={{color:'#fff',fontWeight:600}}>EVENTGO</div> */}
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', cursor: 'pointer' }}>
                        {/* <div style={{
                            width: '99px', height: '28px', alignSelf: 'center', borderRadius: '14px', display: 'flex',
                            border: '1px solid  #636466', justifyContent: 'space-between', lineHeight: '28px', color: '#636466', fontSize: '11px'
                        }}  >
                            <img src={require("../../static/img/1.png")} style={{
                                width: '22px',
                                height: '22px',
                                alignSelf: 'center',
                                borderRadius: '11px',
                                margin: '2px'

                            }} alt="" />
                            <div style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }} >
                                {walletAddressMetamask ? walletAddressMetamask : '0x8…0D3f'}
                            </div>

                            <img src={require("../../static/img/Vector.png")} style={{ width: '6px', height: '4px', alignSelf: 'center', marginRight: 10 }} alt="" />
                        </div> */}

                        <div style={{ display: 'flex', }} onClick={() => getshow2()}>

                            {
                                imgUrls.length > 7 ? <img src={imgUrls} style={{
                                    width: '28px', height: '28px', alignSelf: 'center',
                                    marginLeft: 5, marginRight: 5, borderRadius: '14px',
                                }} alt="" /> :
                                    <div style={{
                                        width: '28px', height: '28px', lineHeight: '28px', borderRadius: '14px', textAlign: 'center', marginLeft: 5, marginRight: 5,
                                        alignSelf: 'center', backgroundColor: randomcolor, color: '#fff', fontSize: '16px'
                                    }} >
                                        {userName ? userName.slice(0, 1).toUpperCase() : ''}
                                    </div>
                            }



                            <img src={require("../../static/img/Vector.png")} style={{ width: '6px', height: '4px', alignSelf: 'center', marginRight: 10 }} alt="" />
                        </div>
                    </div>
                </div>
                {
                    show2 && <div style={{ width: '180px', backgroundColor: '#212327', position: 'absolute', top: '60px', right: 15, zIndex: 999, borderRadius: 10, padding: 10, boxShadow: '4px 4px #101010' }}>
                        <div style={{ display: 'flex', margin: '10px', marginLeft: 0, borderBottomColor: '#414141', borderBottomWidth: 1 }}>
                            {
                                imgUrls.length > 7 ? <img src={imgUrls} style={{
                                    width: '28px', height: '28px', alignSelf: 'center', marginLeft: 5, marginRight: 5,
                                    borderRadius: '14px',
                                }} alt="" /> :
                                    <div style={{
                                        width: '28px', height: '28px', lineHeight: '28px', borderRadius: '14px', textAlign: 'center', marginLeft: 5, marginRight: 5,
                                        alignSelf: 'center', backgroundColor: randomcolor, color: '#fff', fontSize: '16px'
                                    }} >
                                        {userName.slice(0, 1).toUpperCase()}
                                    </div>
                            }

                            <div style={{ marginLeft: 10 }}>
                                <div style={{ color: '#fff', alignSelf: 'center', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: '68px' }}>{userName != '' ? userName : 'Unnamed'}</div>
                                <div style={{ color: '#636466', alignSelf: 'center', width: '68px', whiteSpace: 'nowrap', }}> {walletAddressMetamask ? walletAddressMetamask : '0x8…0D3f'}</div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', cursor: 'pointer' }} >
                            <div style={{ display: 'flex', margin: 10 }}>
                                <img src={require("../../static/img/iconoir_home-alt-slim-horiz.png")} style={{ width: '20px', height: '20px' }} ></img>
                                <div style={{ color: '#fff', alignSelf: 'center', fontSize: '14px', marginLeft: 10 }}>{t('Home')}</div>
                            </div>
                            <Link to={{
                                pathname: '/myevents',
                            }}
                                style={{ color: '#FFF', textDecorationLine: 'none' }}
                            >
                                <div style={{ display: 'flex', margin: 10 }}>
                                    <img src={require("../../static/img/dingyue.png")} style={{ width: '20px', height: '20px' }} ></img>
                                    <div style={{ color: '#fff', alignSelf: 'center', fontSize: '14px', marginLeft: 10 }}>{t('MyEvents')}</div>
                                </div>
                            </Link>
                            <Link to={{
                                pathname: '/UserList',
                            }}
                                style={{ color: '#FFF', textDecorationLine: 'none' }}
                            >
                                <div style={{ display: 'flex', margin: 10 }}>
                                    <div style={{ color: '#fff', alignSelf: 'center', fontSize: '14px', marginLeft: 10 }}>View other people's activities</div>
                                </div>
                            </Link>
                            {/* <div style={{ display: 'flex', margin: 10 }} onClick={() => setlanguage()}>
                                <div style={{ color: '#fff', alignSelf: 'center', fontSize: '14px', marginLeft: 10 }}>{t('Chinese')}/{t('English')}</div>
                            </div> */}
                            {/* <Link to={{
                                pathname: '/Country',
                            }}
                                style={{ color: '#FFF', textDecorationLine: 'none' }}
                            >
                                <div style={{ display: 'flex', margin: 10 }}>

                                    <div style={{ color: '#fff', alignSelf: 'center', fontSize: '14px', marginLeft: 10 }}>{t('Modify Country')}(t{'Onlyfortestinguse'})</div>
                                </div>
                            </Link> */}


                        </div>
                    </div>
                }
            </div>
            <div style={{ alignItems: 'center', margin: '20px' }}>
                <div style={{
                    backgroundColor: '#202225',
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                }}>
                    <div style={{
                        backgroundColor: '#35363B',
                        display: 'flex',
                        justifyContent: 'space-between',
                        flex: 1,
                        marginRight: '20px',
                        height: '32px',
                        borderRadius: '5px',
                        alignItems: 'center',
                    }}>
                        <div style={tabSelected == 0 ? Selected : notselected} onClick={() => Gethomedata(0)}>
                            <div>
                                {t('Upcoming')}
                            </div>
                        </div>
                        <div style={tabSelected == 1 ? Selected : notselected} onClick={() => Gethomedata(1)}>
                            <div>
                                {t('Popular')}
                            </div>
                        </div>
                    </div>

                    <Link to={{
                        pathname: '/search',
                    }}

                        style={{
                            backgroundColor: '#35363B',
                            display: 'flex',
                            justifyContent: 'center',
                            // width: '170px',
                            flex: 1,
                            marginLeft: '20',
                            height: '32px',
                            borderRadius: '5px',
                            alignItems: 'center',
                            color: '#BABBBE',
                            fontSize: '14px',
                            textDecorationLine: 'none'
                        }}>
                        <img src={require("../../static/img/guangqi_guolv.png")} style={{
                            width: '16px',
                            height: '16px',
                            marginRight: 5
                        }} />
                        {t('Filters')}
                    </Link>
                </div>
            </div>
            {/* to={`/plat?longitude=${item.longitude}&latitude=${item.latitude}&eventLocation=${item.eventLocation}`} eventdetails  item.eventId*/}
            <div>
                {
                    upcomingRef.current.map((item: any, index: number) =>
                        <div>{
                            totalref.current >= index + 1 && <Link to={`/eventdetails?eventId=${item.eventId}&country=${country}`
                            }
                                style={{ color: '#FFF', textDecorationLine: 'none' }}

                            >
                                <div key={index} style={{
                                    backgroundColor: '#202225',
                                    alignItems: 'center',
                                    // position: 'relative',
                                    borderRadius: '20px',
                                    padding: '20px',
                                    paddingTop: '0',
                                    paddingBottom: '16px'

                                }}>
                                    <div style={{
                                        width: '100%',
                                        borderRadius: '20px',
                                        backgroundColor: '#35363B',
                                        position: 'relative',
                                    }}>
                                        <div style={{ height: '100px', overflow: 'hidden', }}>

                                            <img src={item.eventBanner.replace('http:','https:')} style={{
                                                width: '100%',
                                                height: '100%',
                                                borderTopRightRadius: '20px',
                                                borderTopLeftRadius: '20px',

                                            }} alt="" />
                                        </div>

                                        {item.sideNumber != 0 && item.sideNumber &&
                                            <div style={{
                                                display: 'flex', height: '30px', lineHeight: '30px', backgroundColor: '#212327',
                                                borderRadius: '30px', justifyContent: 'center', position: 'absolute',
                                                right: '8px', top: '8px', paddingLeft: '10px', paddingRight: '10px', alignItems: 'center'
                                            }}>
                                                <img src={require("../../static/img/tongyongcaidandiejia.png")} style={{
                                                    width: '14px', height: '14px', alignSelf: 'center', marginRight: '5px'
                                                }} alt="" />
                                                {item.sideNumber} {t('Sideevents')}
                                            </div>
                                        }


                                        <div style={{ margin: 10 }}>
                                            {/* <div style={{ fontSize: '24px', fontWeight: 700, padding: 5, }}>{t('NYCFallEvents')}</div> */}
                                           
                                            {/* <div style={{ fontSize: '24px', fontWeight: 700, padding: '5px', marginBottom: '5px', width: '95%',overflow: 'hidden',textOverflow: 'ellipsis',
                                            display: '-webkit-box',WebkitLineClamp: 2,WebkitBoxOrient: 'vertical'	}}>{item.eventName}</div>  */}
                                            <div style={{ fontSize: '24px', fontWeight: 700, padding: '5px', marginBottom: '5px', overflow: 'hidden',whiteSpace: 'nowrap',textOverflow: 'ellipsis', width: '95%' }}>{item.eventName}</div>
                                            <div style={{
                                                color: '#8E929D',
                                                fontSize: '14px',
                                                display: 'flex',
                                                alignItems: 'center'
                                            }}>
                                                <img src={require("../../static/img/Date.png")} style={{
                                                    marginLeft: '5px',
                                                    marginRight: '5px',
                                                    width: '14px',
                                                    height: '14px'
                                                }}></img> {item.time}
                                                {/* {t('6November-7November')} */}
                                            </div>
                                            <Link to={`/plat2?longitude=${item.longitude}&latitude=${item.latitude}&eventLocation=${item.eventLocation}&eventName=${item.eventName}&time=${item.time}&eventId=${item.eventId}`}
                                                style={{ color: '#FFF', textDecorationLine: 'none' }}
                                            >
                                                <div style={{
                                                    color: '#8E929D',
                                                    fontSize: '14px',
                                                    marginTop: '5px',
                                                    display: 'flex',
                                                    alignItems: 'center'

                                                }}>
                                                    <img src={require("../../static/img/tdesign_location.png")} style={{
                                                        marginLeft: '5px',
                                                        marginRight: '5px',
                                                        width: '14px',
                                                        height: '14px',
                                                        // marginTop: '5px'
                                                    }}></img>

                                                    <span >{item.eventCity}</span>
                                                    {item.eventCity && item.eventCountry &&
                                                        <span >,</span>
                                                    }
                                                    <span >

                                                        {item.eventCountry}</span>

                                                </div>
                                            </Link>
                                        </div>
                                        <div style={{ justifyContent: 'space-between', paddingLeft: 15, marginTop: 10, paddingBottom: 20, display: 'flex', paddingTop: '5px' }}>
                                            <div style={{ display: 'flex' }}>
                                                <div style={{ display: 'flex', position: 'relative', height: '24px' }}>
                                                    {item.sdmUsers.map((item2: any, index: number) => <div>
                                                        {
                                                            index < 4 && <div>
                                                                {
                                                                    item2.imgUrl.length > 7 ? <img src={item2.imgUrl} key={index}
                                                                        style={{
                                                                            width: '24px', height: '24px', alignSelf: 'center', borderRadius: '12px',
                                                                            position: 'absolute', left: index * 14, border: '2px solid #2F3039'
                                                                        }} alt="" /> :
                                                                        <div key={index} style={{
                                                                            width: '24px', height: '24px', alignSelf: 'center', lineHeight: "24px", borderRadius: '12px', position: 'absolute', left: index * 14, textAlign: 'center',
                                                                            backgroundColor: item2.c, color: '#fff', fontSize: '16px', border: '2px solid #2F3039'
                                                                        }} >{item2.sdmUserName != null ? item2.sdmUserName.slice(0, 1).toUpperCase() : ''}</div>
                                                                }

                                                            </div>
                                                        }

                                                        {
                                                            index == 4 && <img src={require("../../static/img/Group.png")} key={index}
                                                                style={{
                                                                    width: '24px', height: '24px', position: 'absolute', left: 56, alignSelf: 'center',
                                                                    borderRadius: '12px'
                                                                }}></img>
                                                        }
                                                    </div>
                                                    )}
                                                </div>


                                            </div>
                                            {item.people > 0 &&
                                                <div style={{ fontSize: '12px', color: '#BABBBE', height: '24px', lineHeight: '24px', flex: 1, textAlign: 'center', marginTop: '2px' }}>
                                                    <span style={{ marginRight: '5px' }}> {item.people}</span>{t('friendswillgo')}
                                                </div>
                                            }
                                            <div style={{ display: 'flex', marginRight: 20, color: '#FFFFFF', fontSize: '20px', fontWeight: 700 }}>
                                                <img src={require("../../static/img/Vector2.png")} style={{
                                                    width: '12.5px',
                                                    height: '20px', marginRight: '5px'
                                                }} ></img>
                                                {item.eventNumber ? item.eventNumber : 0}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        }


                        </div>




                    )
                }
            </div>

        </div >

        {/* {
            showhasMore && <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
        } */}

        <div style={{ backgroundColor: '#202225' }}>
            <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
        </div>

    </div>;

};



export default Home;



